module.exports = __webpack_public_path__ + "img/orden-w.cf45f42f.svg";